import Empty from '@/assets/placeholders/empty.png';

import { CoinChartColorType, WhiteLabelTheme } from '../types';

import CardBackground from './assets/card-background.svg';
import CardLogo from './assets/card-logo.svg';
import DashboardBanner from './assets/dashboard-banner.svg';
import LoginBackground from './assets/login-background.svg';
import LogoIcon from './assets/logo.svg';
import manageProfileBanner from './assets/manageProfileBanner.svg';
import SmallLogoIcon from './assets/minify-logo.svg';
import ReimburseMeSidebarBackground from './assets/reimburseMe-sidebar-background.svg';
import SignInLogo from './assets/signIn-logo.svg';
import VerificationBanner from './assets/verificationBackground.svg';

const buttonColors = {
  onDarkButtonPrimary: '#367E56',
  onDarkButtonPrimaryHover: '#237447',
  onDarkButtonPrimaryActive: '#174A2D',
  onDarkButtonPrimaryPressed: '#174A2D',
  onDarkButtonPrimaryDisabled: '#1B4A30',

  onDarkButtonSecondaryHoverBorder: '#367E56',
  onDarkButtonSecondaryActiveBorder: '#2D784E',
  onDarkButtonSecondaryDisabledBorder: '#515151',
  onDarkButtonSecondaryDisabled: '#333333',
  onDarkButtonSecondaryHover: '#4A6355',

  onDarkModuleBackground: '#404040',
  onDarkBackground: '#333333',

  buttonPrimary: '#2E8B57',
  buttonPrimaryHover: '#1C7A4D',
  buttonPrimaryActive: '#1D5435',
  buttonPrimaryPressed: '#1C7A4D',
  buttonPrimaryDisabled: '#E5E9F0',

  buttonSecondaryHoverBorder: '#2E8B57',
  buttonSecondaryActiveBorder: '#1D5435',
  buttonSecondaryDisabledBorder: '#E5E9F0',
  buttonSecondaryDisabled: '#FFFFFF',
  buttonSecondaryHover: '#D8FEE9',

  buttonTertiaryHover: '#D8FEE9',
  buttonTertiaryPressed: '#CBEEDE',
  buttonTertiaryDisabled: '#E5E9F0',
  buttonSecondaryContainer: '#CBEEDE',
};
const navigationColors = {
  navigationBackground: '#F7F8F9',
  navigationBorder: '#E8E8E8',
  navigationAccent: '#CBEEDE',
  navigationAccent2: '#2E8B57',
  navigationTextDefault: '#000000',
  navigationTextAccent: '#2E8B57',
  navigationIconDefault: '#000000',
  navigationIconAccent: '#2E8B57',
  navigationAccentHover: '#CBEEDE',
  navigationAccentActive: '#CBEEDE',
};
const backgroundColors = {
  background1: '#2E8B57',
  background2: '#333333',
  background3: '#000000',

  border: '#B8BFCC',
  border1: '#E5E9F0',
  border2: '#EEF1F4',
  module: '#F7F8F9',
  canvas: '#FFFFFF',
  stressContainer: '#333333',
  accentActive: '#2E8B57',
  accentBorder: '#87C4A2',
  accentContainer: '#CBEEDE',
  popupBg2: '#0F16210D',
  legend: '#CCD2DC',
};
const baseColors = {
  ...buttonColors,
  ...navigationColors,
  ...backgroundColors,

  textTitle: '#000000',
  textBody: '#000000',

  textSecondary: '#63656A',
  textDisabled: '#848B99',
  textOnColor: '#FFFFFF',
  textAccent: '#2E8B57',
  textAccentHover: '#1C7A4D',
  textAccentActive: '#1D5435',

  iconPrimary: '#000000',
  iconSecondary: '#63656A',
  iconOnColor: '#FFFFFF',
  iconAccent: '#2E8B57',
  iconAccentHover: '#1C7A4D',
  iconAccentActive: '#1D5435',
  iconDisabled: '#848B99',

  success: '#4EAB50',
  successBorder: '#B8F8C8',
  successContainer: '#E9FFEF',

  warning: '#FFCC00',
  warningBorder: '#FFF0B8',
  warningContainer: '#FFFBEC',

  danger: '#E23131',
  dangerBorder: '#F6C4C4',
  dangerContainer: '#FFF3F3',
  dangerHover: '#971C1C',
  dangerActive: '#7C1414',

  info: '#19BCCE',
  infoBorder: '#B2F4FF',
  infoContainer: '#F0FDFF',

  transactionMedical: '#00C3B3',
  transactionDental: '#176AF6',
  transactionVision: '#481A54',
  transactionOther: '#FF9D0A',
  transactionParking: '#323D9B',
  transactionTransit: '#9BBF84',
  transactionAdoption: '#0F7970',
  transactionDependentCare: '#CC3381',
  transactionPharmacy: '#D83B00',
  transactionLifestyle: '#D3375C',
  transactionPremium: '#3628D1',
  transactionTravel: '#F26B31',
  transactionWellness: '#9B31F2',
  transactionPlanSpecific: '#00B5EE',
  refund: '#588C0E',
  transactionDefault: '#5E697E',
  claimTransferInternal: '#E5E9F0',
  nonClaimIcon: '#151F6D',
  nonClaimBg: '#E5E9F0',

  planTypeHSA: '#2EA12B',
  planTypeHCFSA: '#FA802A',
  planTypeDCAP: '#CC3381',
  planTypeHRA: '#134E8F',
  planTypeCommuterTransit: '#9BBF84',
  planTypeCommuterParking: '#323D9B',
  planTypeAdoption: '#0F7970',
  planTypeLifestyle: '#D3375C',
  planTypeSpecialty: '#00B5EE',
  planTypeTravel: '#F26B31',
  planTypeRx: '#7909AD',
  planTypeDental: '#176AF6',
  planTypeVision: '#481A54',
  planTypeMedical: '#00C3B3',

  lockedNull: '#000000',
  processingPending: '#F9C134',
  needsHelp: '#FF9D0A',
  paidActiveComplete: '#19B269',
  partiallyPaid: '#B9CC29',
  waitingForFunds: '#8EB2A1',
  deniedErrorExpired: '#E72626',
  uploading: '#9BA3B3',
  uploadedApproved: '#176AF6',
  loa: '#00B5EE',
  retirement: '#CE8258',
  future: '#7909AD',

  missingDetail: '#FB6D2A',
  missingContainer: '#FFF3EE',
  missingBorder: '#FEDACA',

  investmentsfuture: '#7909AD',
  investmentsFund1: '#3F68FF',
  investmentsFund2: '#10D8B9',
  investmentsFund3: '#FB5C20',
  investmentsFund4: '#FC990F',
  investmentsFund5: '#FDD137',
  investmentsFund6: '#BCD1EF',
  investmentsFund7: '#323D9B',
  investmentsFund8: '#F3C626',
  investmentsFund9: '#A528C6',
  investmentsFund10: '#0C95D0',
  investmentsFund11: '#619C00',
  investmentsFund12: '#CC3381',
  investmentBackground: '#2D2D2D',
  profitContainer: '#00FF9314',
  lossContainer: '#EF235D14',
  chart: '#2E8B57',
  coinChart: ['#4A8B66', '#E6FFF1', '#A3EAC2', '#E6FFF1', '#99DEB7'] as CoinChartColorType,

  partner: '#D83B00',
  distributor: '#904D27',
  employer: '#174FBC',
  subsidiary: '#0F7970',
  subgroup: '#481A54',
  claimProcessor: '#176AF6',
  employee: '#0CAD09',
  dependent: '#5E1696',
  noAssignee: '#B8BFCC',

  claimParticipant: '#CC3381',
  claimSystem: '#18A0FB',
  claimCardProcessor: '#19B269',

  uploadLinkBackground: '#2E8B57',
};
export default {
  title: 'RMR',
  loginScreenTitle: 'Start getting the benefit out of your benefits plan',
  termsAndConditions: 'https://www.rockymountainreserve.com/terms-of-use',
  privacyPolicy: 'https://www.rockymountainreserve.com/privacy',

  IOSAppStoreLink: 'https://apps.apple.com/us/app/rmr-benefits/id6479498415',
  androidAppStoreLink: 'https://play.google.com/store/apps/details?id=com.rockymountainreserve.rmr_app',

  IOSAppLink: 'elevate://open-app',
  androidAppLink: 'elevate://open-app',

  mobileAppIcon: SmallLogoIcon,
  mobileAppTitle: 'RMR Benefits',

  colors: {
    ...baseColors,
    loginTitleColor: baseColors.textBody,

    popup: 'rgba(15, 22, 33, 0.5)',
    popup2: 'rgba(15, 22, 33, 0.05)',
    fade1: 'linear-gradient(0deg, #F7F9FA 0%, rgba(255, 255, 255, 0.00) 100%)',
    fade2: 'linear-gradient(180deg, #F7F9FA 0%, #EEF1F4 100%)',
  },
  logo: LogoIcon,
  minifyLogo: SmallLogoIcon,
  font: "'Open Sans'", // Also you need add font import to global.scss example: @import url('https://fonts.googleapis.com/css2?family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap');
  titleFont: "'Open Sans'",
  tetriaryAccentButton: true,

  //wait for design
  images: {
    banner: DashboardBanner,
    cardBackground: CardBackground,
    loginBackground: LoginBackground,
    cardLogo: CardLogo,
    sidebarLogo: LogoIcon,
    sidebarMinifyLogo: SmallLogoIcon,
    qrCodeLogo: SmallLogoIcon,
    investmentsBannerRight: Empty,
    reimburseMeSidebar: ReimburseMeSidebarBackground,
    signUpSidebar: Empty,
    settingsIllustration: '',
    verificationBackground: VerificationBanner,
    signInLogo: SignInLogo,
    manageProfileBannerBackground: manageProfileBanner,
  },

  fonts: {
    sidebarWeight: 500,
    sidebarFontSize: '14px',
    reimbursementWeight: 500,
    sizes: {
      small: {
        size: '12px',
        height: '16px',
        maxWidth: '336px',
      },
      '3xl': {
        size: '30px',
        height: '40px',
        maxWidth: '1008px',
      },
      '2xl': {
        size: '24px',
        height: '30px',
        maxWidth: '816px',
      },
    },
  },
  rounds: {
    moduleRound: '24px',
    container1Round: '12px',
    container2Round: '8px',
    checkboxRound: '6px',
    fieldRound: '8px',
    button1Round: '8px',
    button2Round: '4px',
    dropdownItemRound: '4px',
    snackbarRound: '4px',
  },

  shadows: {
    default: '0px 6px 15px rgba(0, 0, 0, 0.04);',
    hover: '0px 8px 15px rgba(0, 0, 0, 0.10);',
    active: '0px 8px 25px rgba(33, 117, 44, 0.25);',
    highlighted: '0px 6px 16px rgba(46, 139, 87, 0.5);',
  },
  favicon: '/rmr/favicon.ico',
  favicon16: '/rmr/favicon-16x16.png',
  favicon32: '/rmr/favicon-32x32.png',
  faviconAppleTouch: '/rmr/apple-touch-icon.png',
} as WhiteLabelTheme;
